import React from 'react'
import PUC from './Logos/UC'
import UCH from './Logos/UDeChile'
import UdeC from './Logos/UDeConcepcion'
import PUCV from './Logos/PUCV'
import UAH from './Logos/UAH'
import UAI from './Logos/UAI'
import UAndes from './Logos/UAndes'
import UTFSM from './Logos/UTFSM'
import UAustral from './Logos/UAustral'
import UCN from './Logos/UCN'
import UCM from './Logos/UCM'
import UCSC from './Logos/UCSC'
import USACH from './Logos/USACH'

import UDP from './Logos/UDP'
import UFRO from './Logos/UFRO'
import UValpo from './Logos/UValpo'
import UDD from './Logos/UDD'
import UMayor from './Logos/UMayor'
import UTalca from './Logos/UTalca'
import UNAP from './Logos/UNAP'
import UBiobio from './Logos/UBiobio'

import UCen from './Logos/Ucen'
import Unab from './Logos/Unab'
import UTarapaca from './Logos/UTarapaca'

const UniversityLogo = ({ university, ...rest }) => {
  return (
    <div className="logo-wrapper">
      {university === 'PUC' && <PUC {...rest} />}
      {university === 'UChile' && <UCH {...rest} />}
      {university === 'UdeC' && <UdeC {...rest} />}
      {university === 'PUCV' && <PUCV {...rest} />}
      {university === 'UAH' && <UAH {...rest} />}
      {university === 'UAI' && <UAI {...rest} />}
      {university === 'UAndes' && <UAndes {...rest} />}
      {university === 'UTFSM' && <UTFSM {...rest} />}
      {university === 'UDP' && <UDP {...rest} />}
      {university === 'UACH' && <UAustral {...rest} />}
      {university === 'UCN' && <UCN {...rest} />}
      {university === 'UCMaule' && <UCM {...rest} />}
      {university === 'UCSConce' && <UCSC {...rest} />}
      {university === 'USACH' && <USACH {...rest} />}
      {university === 'UFRO' && <UFRO {...rest} />}
      {university === 'UValpo' && <UValpo {...rest} />}
      {university === 'UDesarrollo' && <UDD {...rest} />}
      {university === 'UMayor' && <UMayor {...rest} />}
      {university === 'UTalca' && <UTalca {...rest} />}
      {university === 'UAPrat' && <UNAP {...rest} />}
      {university === 'Ubiobio' && <UBiobio {...rest} />}
      {university === 'UNAB' && <Unab {...rest} />}
      {university === 'UCentral' && <UCen {...rest} />}
      {university === 'UTarapaca' && <UTarapaca {...rest} />}
    </div>
  )
}

export default UniversityLogo
